import moment from "moment";
import "moment/locale/es";

moment.locale("es");

const daysOfTheWeek = {
    lunes: "LUN",
    martes: "MAR",
    miércoles: "MIE",
    jueves: "JUE",
    viernes: "VIE",
    sábado: "SAB",
    domingo: "DOM",
};

export const getDayOfTheWeek = (date) => {
    return daysOfTheWeek[moment(date).format("dddd")];
};
